<template>
  <div>
    <slot name="list-heading"></slot>
    
    <slot 
      name="list-controls" 
      :filter-options="filterOptions"
      :filters="filters"
      :set-page="setPage"
      :items="getCorrectList"
    ></slot>

    <pager 
      v-if="itemsPerPage < filteredList.length" 
      :items-length="filteredList.length" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      @page-to="(payload) => this.activeIndex = payload"
      className="pager_borderBottom"
      >
    </pager>

    <template v-if="getCorrectList.length > 0">
      <!-- list iterator placeholder (for simple lists uses ListDisplay) -->
      <slot name="list-display" :items="getCorrectList" :list-display-wrapper-class="blockColumnsClass">
      </slot>
    </template>
    <template v-else>
      <slot name="list-no-results"></slot>
    </template>

    <pager 
      v-if="itemsPerPage < filteredList.length" 
      :items-length="filteredList.length" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      className="pager_borderTop"
      @page-to="(payload) => this.activeIndex = payload"
      >
    </pager>


  </div>
</template>

<script>
import Pager from './Pager.vue'
import ListDisplay from './ListDisplay.vue';

export default {
  components: {
    Pager,
  },
  props: {
    items: {
      type: Array
    },
    filterOptions: {
      type: Object
    },
    blockColumns: {
      type: Number
    },
    blockColumnsOverride: {
      type: String
    },
    itemsPerPage: {
      type: Number
    }
  },
  data() {
    return {
      filters: {},
      activeIndex: 0
    };
  },
  created() {
    //dynamically create filters in data object
    for (const item in this.filterOptions) {
      // needs to use $set method to hook up reactivity
      this.$set(this.filters, item, "");
    }
  },
  computed: {
    filteredList() {
      return this.filterList(this.items, this.filters);
    },
    pagedList() {
      return this.filteredList.slice(this.activeIndex,this.activeIndex + this.itemsPerPage);
    },
    getCorrectList() {
      // return paged list if attribute is specified, else return stimple filtered list
      if (this.itemsPerPage) { 
        return this.pagedList;
      }
      return this.filteredList;
    },
    blockColumnsClass() {
      // MD block columns will be half of LG rounded up.
      if(this.blockColumnsOverride) {
          return this.blockColumnsOverride;
      }
      if (this.blockColumns === 2) {
        return `flexBlocks flexBlocks_2upMD flexBlocks_2upLG` 
      }
      return `flexBlocks flexBlocks_${Math.ceil(this.blockColumns / 2)}upMD flexBlocks_${this.blockColumns}upLG`
    }
  },
  methods: {
    selectFilter(category, value) {
      this.filters[category] = value;
    },
    setPage(page) {
      this.activeIndex = page;
    },
    filterList(items, filters) {
      var stuff = items.filter(item => {
        let include = true;
        for (var filter in filters) {
          // check for type of filter
          if (typeof item[filter] === "number") {
            
            if (
              item[filter] == undefined ||
              item[filter].toString().indexOf(filters[filter]) === -1
            ) {
              include = false;
            }
          }else if (typeof item[filter] === "string") {
            if (
              item[filter] == undefined ||
              item[filter].indexOf(filters[filter]) === -1
            ) {
              include = false;
            }
          } else {
            throw new Error(
              "Error in FilterList: Type of filter does not match item type"
            );
          }
        }
        return include;
      });
      return stuff;
    }
  }
};
</script>

<style lang="scss">
</style>

